module.exports = __webpack_public_path__ + "img/desire_004.3a648e0.webp";